module.exports = __webpack_public_path__ + "static/media/hii.93750ace.ogg";